import React, { useState, useEffect, Fragment } from 'react';
import ListIcon from '../../images/bevego/list.svg';
import GridIcon from '../../images/bevego/window.svg';

const ProductListSorting = () => {
    const [productListElement] = useState(
        document.getElementById('product-list')
    );

    const [isListViewActive, setIsListViewActive] = useState(true);
    const [isGridViewActive, setIsGridViewActive] = useState(false);
    const selectedViewSession = window.sessionStorage.getItem("selectedView");

    const setGrid = () => {
        setIsListViewActive(false);
        setIsGridViewActive(true);
        productListElement.classList.remove('product-list__list');
        productListElement.classList.add('product-list__grid');
    }
    const setList = () => {
        setIsListViewActive(true);
        setIsGridViewActive(false);
        productListElement.classList.add('product-list__list');
        productListElement.classList.remove('product-list__grid');
    };

    useEffect(() => {
        if (selectedViewSession != null && productListElement != null) {
            if (selectedViewSession === "list") {
                setList();
            } else if (selectedViewSession === "grid") {
                setGrid();
            }
        }
    }, []);

    const viewGrid = () => {
            window.sessionStorage.removeItem("selectedView");
            window.sessionStorage.setItem("selectedView", "grid");
            setGrid();
    };
    const viewList = () => {
            window.sessionStorage.removeItem("selectedView");
            window.sessionStorage.setItem("selectedView", "list");
            setList();
    };

    return (
        <Fragment>
            {productListElement != null ?
                <div className="product-list__sort-container">
                    <div className="product-list__btn-container">
                        <ListIcon onClick={() => viewList()} className={`product-list__list-icon ${isListViewActive
                            ? 'product-list__icon-active'
                            : 'product-list__icon-disabled'
                            }`} />
                        <GridIcon onClick={() => viewGrid()} className={`product-list__grid-icon ${isGridViewActive
                            ? 'product-list__icon-active'
                            : 'product-list__icon-disabled'
                            }`} />
                    </div>
                </div>
                : null
            }
        </Fragment>
    );
};

export default ProductListSorting;
